<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">{{ $t("t_manager_api") }}</h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_handle('create', null)"
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="left"
                  ref="ruleFormRef"
                  @submit.prevent
                  :rules="rulesForm"
                  :model="tableRules.dataSearch.value"
                >
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item :label="$t('t_code_api')">
                        <el-input
                          size="large"
                          clearable
                          v-model="tableRules.dataSearch.value['code']"
                          :placeholder="$t('t_code_api_placeholder')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item :label="$t('t_name_api')">
                        <el-input
                          size="large"
                          clearable
                          v-model="tableRules.dataSearch.value['name']"
                          :placeholder="$t('t_name_api_placeholder')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item :label="$t('t_type_api')">
                        <el-select
                          size="large"
                          v-model="tableRules.dataSearch.value['type']"
                          clearable
                          filterable
                          :placeholder="$t('t_type_api_placeholder')"
                        >
                          <el-option
                            v-for="item in listTypeAPI"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6" style="text-align: right">
                      <a
                        class="btn btn-soft-secondary btn-border waves-effect waves-light mx-3"
                        style="width: 80px"
                        @click="fn_showFormTimKiem()"
                      >
                        {{ $t("t-hide") }}
                      </a>
                      <button
                        class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                        style="width: 100px"
                        native-type="submit"
                        @click="fn_TimKiem()"
                      >
                        {{ $t("t-search") }}
                      </button>
                    </el-col>
                  </el-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            max-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="70"
              align="center"
              fixed
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="code"
              :label="$t('t_code_api')"
              min-width="180"
              align="left"
              :sortable="true"
              fixed
            >
              <template #default="scope">
                <el-tooltip
                  class="item"
                  popper-class="custom-tooltip"
                  effect="light"
                  :content="scope.row.code"
                  placement="top-start"
                >
                  <span class="truncate-text">{{ scope.row.code }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('t_name_api')"
              min-width="200"
              align="left"
              :sortable="true"
            >
              <template #default="scope">
                <el-tooltip
                  class="item"
                  popper-class="custom-tooltip"
                  effect="light"
                  :content="scope.row.name"
                  placement="top-start"
                >
                  <span class="truncate-text">{{ scope.row.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="type"
              :label="$t('t_type_api')"
              width="100"
              align="center"
            >
              <template #default="scope">
                <el-tag
                  v-if="scope.row.type === 'sync'"
                  type="primary"
                  effect="light"
                  class="text-uppercase"
                  style="min-width: 80px"
                >
                  {{ scope.row.type }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.type === 'async'"
                  type="warning"
                  effect="light"
                  class="text-uppercase"
                  style="min-width: 80px"
                >
                  {{ scope.row.type }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.type === 'dynamic'"
                  effect="dark"
                  class="text-uppercase"
                  style="
                    min-width: 80px;
                    border-color: rgba(54, 69, 116, 0.2);
                    color: #364574;
                    background-color: rgba(54, 69, 116, 0.2);
                  "
                >
                  {{ scope.row.type }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.type === 'file'"
                  effect="dark"
                  class="text-uppercase"
                  style="
                    min-width: 80px;
                    border-color: rgba(114, 46, 209, 0.2);
                    color: #722ed1;
                    background-color: rgba(114, 46, 209, 0.2);
                  "
                >
                  {{ scope.row.type }}
                </el-tag>
                <span v-else>{{ scope.row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="multi_probe"
              :label="$t('t_multi_probe')"
              width="80"
              align="center"
            >
              <template #default="scope">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i
                    v-if="scope.row.multi_probe"
                    class="ri-checkbox-circle-fill"
                    style="color: #0ab39c; font-size: 20px"
                  ></i>
                  <i
                    v-else
                    class="ri-close-circle-fill"
                    style="color: #ff5b5b; font-size: 20px"
                  ></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="config.probe_picker_type"
              :label="$t('t_probe_picker_type')"
              width="130"
              align="center"
            >
              <template #default="scope">
                <el-tag
                  v-if="scope.row.config.probe_picker_type === 'automatic'"
                  type="primary"
                  effect="light"
                  class="text-uppercase"
                  style="min-width: 80px"
                >
                  Device code
                </el-tag>
                <el-tag
                  v-else-if="
                    scope.row.config.probe_picker_type === 'probe_column'
                  "
                  type="warning"
                  effect="light"
                  class="text-uppercase"
                  style="min-width: 80px"
                >
                  Web defined
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('t-description')"
              min-width="200"
              align="left"
            >
              <template #default="scope">
                <el-tooltip
                  class="item"
                  popper-class="custom-tooltip"
                  effect="light"
                  :content="scope.row.description"
                  placement="top-start"
                >
                  <span class="truncate-text">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="120px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import MethodService from "../../service/MethodService";
import Swal from "sweetalert2";
import toastr from "toastr";
import DataForm from "./dataQuanLyAPI";
import mushroom from "cem-primary-api";
import { useI18n } from "vue-i18n";
import { Filter } from "mushroomjs";
const { t } = useI18n();
let loading = ref(true);
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const dataTables = reactive({ value: [] });
const pageSizeDefault = ref(20);
const listTypeAPI = DataForm.typeAPI;
const listSocketGroupAPI = ref([]);
const socketGroupConfigDefault = ref({
  id: "",
  name: "",
});
const fn_handle = (type, row) => {
  if (type === "create") {
    router.push({ name: "CreateAPI" });
  }
  if (type === "update") {
    console.log(row.id);

    router.push({
      name: "UpdateAPI",
      params: { id: row.id },
    });
  }
  if (type === "delete") {
    Swal.fire({
      title: t("swal_noti"),
      text: t("t_noti_delete_api_definition"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.api_definition.deleteAsync({
            id: row.id,
          });
          if (response.result) {
            toastr.success(t("t_delete_api_definition"));
            fetchApiDefinition();
          }
        } catch (e) {
          MethodService.showError(e.code);
        }
      }
    });
  }
};
const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  router
    .replace(MethodService.routerReplace("ListAPI", tableRules))
    .catch(() => {});
};
const fn_TimKiem = () => {
  if (tableRules.dataSearch.value["code"]) {
    tableRules.dataSearch.value["code"] =
      tableRules.dataSearch.value["code"].trim();
  }
  tableRules.filters = MethodService.filterTable(
    JSON.stringify(tableRules.dataSearch)
  );
  tableRules.offset = 0;
  tableRules.sort = "";
  fetchApiDefinition();
};
const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};
const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};
const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};
const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};
const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  fetchApiDefinition();
};
const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  fetchApiDefinition();
};
const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

const fetchSocketGroup = async () => {
  try {
    const response = await mushroom.api_socket_group.getAllAsync();
    listSocketGroupAPI.value = response.result.map((res) => ({
      value: res.id,
      label: res.name,
    }));
  } catch (e) {
    MethodService.showError(e.code);
  }
};

const fetchSocketGroupConfigDefault = async () => {
  try {
    const { result } = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "default_socket_group_id").build(),
    });
    const idSocketGroupDefault = result?.[0]?.value;
    if (!idSocketGroupDefault) return;

    const group = listSocketGroupAPI.value.find(
      (item) => item.value === idSocketGroupDefault
    );

    if (group) {
      socketGroupConfigDefault.value = {
        id: idSocketGroupDefault,
        name: group.label,
      };
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const fetchApiDefinition = async () => {
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
  };
  router
    .replace(MethodService.routerReplace("ListAPI", tableRules))
    .catch(() => {});
  try {
    const response = await mushroom.api_definition.listAsync(dataFilter);
    if (response.result) {
      dataTables.value = response.result.map((item) => ({
        ...item,
        config: item.config || {},
      }));
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fn_hashUrl();
  await fetchSocketGroup();
  await Promise.all([fetchSocketGroupConfigDefault(), fetchApiDefinition()]);
});
</script>

<style scoped>
.truncate-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.custom-tooltip {
  max-width: 300px !important;
  word-break: break-all !important;
  white-space: normal !important;
}
</style>
